import { useEffect, useRef, useState } from 'react'
import { Game } from '../srm/srm-parser'
import GameCard, { GameCardHandle } from './GameCard'

function GameStatsView({
  games,
  onOpenFile,
  onExport,
  isDragging
}: {
  games: { a: Game; b: Game; c: Game }
  onOpenFile: () => void
  onExport: (games: { a: Game; b: Game; c: Game }) => void
  isDragging: boolean
}) {
  const [menuOpen, setMenuOpen] = useState(false)
  const menuRef = useRef<HTMLDivElement>(null)
  const refA = useRef<GameCardHandle>(null)
  const refB = useRef<GameCardHandle>(null)
  const refC = useRef<GameCardHandle>(null)

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setMenuOpen(false)
      }
    }
    if (menuOpen) document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [menuOpen])

  const handleExport = () => {
    onExport({
      a: refA.current!.getGame(),
      b: refB.current!.getGame(),
      c: refC.current!.getGame()
    })
  }

  return (
    <div className={`stats-view${isDragging ? ' stats-view--dragging' : ''}`}>
      <header className="stats-header">
        <span className="stats-header-title">Super Metroid Save Editor</span>
        <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
          <button className="menu-btn" onClick={handleExport}>
            Export
          </button>
          <div className="menu-wrapper" ref={menuRef}>
            <button
              className="menu-btn"
              onClick={() => setMenuOpen((prev) => !prev)}
            >
              Menu
            </button>
            {menuOpen && (
              <div className="menu-dropdown">
                <button
                  className="menu-item"
                  onClick={() => {
                    setMenuOpen(false)
                    onOpenFile()
                  }}
                >
                  Open another file
                </button>
              </div>
            )}
          </div>
        </div>
      </header>

      <main className="stats-content">
        {isDragging && <div className="drop-overlay">Release to load file</div>}
        <GameCard ref={refA} label="Game A" game={games.a} />
        <GameCard ref={refB} label="Game B" game={games.b} />
        <GameCard ref={refC} label="Game C" game={games.c} />
      </main>
    </div>
  )
}

export default GameStatsView
